var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"container",style:({
    backgroundImage: ("url('static/img/wallpapers/wp" + (1 + Math.floor(Math.random() * 7)) + ".jpg')"),
  }),attrs:{"fill-height":"","fluid":""}},[_c('div',{staticClass:"overlay",staticStyle:{"z-index":"1000"}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('router-view')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-455ac8da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Out.vue
// module id = 318
// module chunks = 1